export interface Vendor {
  id: number;
  code: string;
  name: string;
  active: boolean;
  /** For Add Vendor modal conflicts filter (UI-only). */
  hasVendorConflict?: boolean;
  /** Other rate amount shown in row toggle tooltip when set. */
  activeOnOtherRateAmount?: number;
  /** Other service type label for tooltip when set. */
  activeOnOtherServiceType?: string;
}

export const mockVendorsData: Vendor[] = [
  {
    id: 1,
    code: "M1G3",
    name: "England CR",
    active: true,
  },
  {
    id: 2,
    code: "M2G3",
    name: "England CR",
    active: true,
  },
  {
    id: 3,
    code: "M3G3",
    name: "England CR",
    active: true,
  },
  {
    id: 4,
    code: "M4G3",
    name: "England CR",
    active: true,
  },
  {
    id: 5,
    code: "M5G3",
    name: "England CR",
    active: true,
  },
  {
    id: 6,
    code: "M6G3",
    name: "England CR",
    active: true,
  },
  {
    id: 7,
    code: "M7G3",
    name: "England CR",
    active: true,
  },
  {
    id: 8,
    code: "M8G3",
    name: "England CR",
    active: true,
  },
  {
    id: 9,
    code: "M9G3",
    name: "England CR",
    active: true,
  },
  {
    id: 10,
    code: "M10G3",
    name: "England CR",
    active: true,
  },
  {
    id: 11,
    code: "M163",
    name: "Avileno Trucking",
    active: true,
    hasVendorConflict: true,
    activeOnOtherRateAmount: 1.56,
    activeOnOtherServiceType: "Fleet Rate",
  },
];
